import { useMemo } from "react";
import { Provider } from "react-redux";
import BulkApplyMarketReports from "./BulkApplyMarketReports";

const BulkApplyMarketReportsApp = (props) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <BulkApplyMarketReports {...props} />
    </Provider>
  );
};

export default BulkApplyMarketReportsApp;
